<template>
  <div class="w-full h-full flex flex-col px-12px py-12px" v-if="islogin">
    <div class="w-full flex justify-between items-center">
      <div class="panel-title" @click="handleBackClick">
        <el-icon class=" back-icon cursor-pointer" v-if="folderActive.id">
          <ArrowLeft />
        </el-icon>
        {{ folderActive.name || '我的资源' }}
      </div>
      <el-dropdown trigger="click" @command="onPlusCommand">
        <div
          class="plus cursor-pointer flex items-center gap-[5px]  h-[32px] bg-[#f5f7fa] rounded-[4px] text-[14px] font-400 text-[#38393b] px-12px">
          <ElIcon size="16px">
            <Plus />
          </ElIcon>
          <span class="font-400">添加</span>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="upload">上传文件</el-dropdown-item>
            <el-dropdown-item command="folder">创建文件夹</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <input ref="fileInput" type="file" class="hidden-input position-fixed top-0 left-0 w-[0px] h-[0px] opacity-0"
      accept=".png,.jpg,.jpeg,.webp,.svg" @change="onFileChange" />
    <div class="search flex items-center mt-12px w-full">
      <el-input v-model="searchValue" placeholder="请输入搜索内容" clearable :prefix-icon="Search" class="w-full" />
    </div>
    <div class="w-full font-bold mt-12px mb-[12px]" v-if="folders.length > 0">文件夹</div>
    <div class="folderList flex flex-wrap gap-[10px] justify-start w-full">
      <div class="items px-[12px] py-[8px] w-[80px]  bg-[#f5f7fa] rounded-[4px] " v-for="item in folders" :key="item"
        @click="handleFolderClick(item)">
        <img class="w-[50px] mx-auto rounded-[4px]"
          src="https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/shanyin-design/image/user/7_1764320312000_456ecf4d-7469-4154-bf90-b9e8ca39a9e9.png"
          alt="">
        <div class="font-400 mt-[4px] w-full overflow-hidden text-ellipsis whitespace-nowrap text-[12px] text-center">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="filter flex items-center  mt-12px w-full h-40px"
      style="justify-content: space-between;border-bottom: 1px solid rgb(230, 230, 230);">
      <div class=" tab flex items-center gap-[10px]">
        <div class="tab-title cursor-pointer" v-for="tab in tabs" :key="tab.name" @click="activeTab = tab.name"
          :class="{ 'select-bg': activeTab == tab.name }">{{
            tab.label }}</div>
      </div>
      <div class="filter cursor-pointer flex items-center gap-[10px]">
        <div style="font-weight: bolder;" @click="folderOpen = !folderOpen">
          <ElIcon size="20px">
            <FolderRemove v-if="!folderOpen" />
            <FolderOpened v-else />
          </ElIcon>
        </div>
      </div>
    </div>
    <div class="flex-1 min-h-0 overflow-auto">
      <div v-show="activeTab == 'work'" class="h-full">
        <templatepage :id="folderActive.id" />
      </div>
      <div v-show="activeTab == 'myUpload'" class="h-full">
        <myUpload :id="folderActive.id" ref="myUploadRef" />
      </div>
    </div>
    <div class="px-[12px] w-full cursor-pointer" v-if="remainingCapacity">
      <div class="w-full h-[10px] bg-[#f5f7fa] rounded-[5px] overflow-hidden mb-[12px]">
        <div class="w-full h-[10px] bg-[#2a66ff] rounded-[5px]"
          :style="{ width: `${(remainingCapacity.used_capacity / remainingCapacity.capacity) * 100}%` }"></div>
      </div>
      <!-- <el-slider v-model="remainingCapacity.used_capacity" disabled :show-tooltip="false" :min="0"
        :max="remainingCapacity.capacity"></el-slider> -->
      <div class="text-[12px] text-[#666]">{{ remainingCapacity.used_capacity }}Mb/{{ (remainingCapacity.capacity /
        1024)
      }}G
      </div>
    </div>

  </div>
  <div v-else class="w-full h-full flex items-center justify-center">
    <div class="text-center">
      <div class="text-[14px] text-[#666] mb-[8px]">请先登录</div>
      <el-button type="primary" style="background-color:#2a66ff;" @click="handleLogin">登录/注册</el-button>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ElInput, ElButton, ElIcon, ElDropdown, ElDropdownMenu, ElDropdownItem, ElMessageBox, ElMessage, ElSlider } from 'element-plus'
import { Folder, Search, Filter, FolderRemove, FolderOpened, Plus, ArrowLeft } from '@element-plus/icons-vue'
import { ref, computed, onMounted } from 'vue'
import { createFolder, getFolderList, getResourceCapacity } from '@/api/affairs'
import { resourcerFileUpload } from '@/api/design/resource'
//@ts-ignore
import myUpload from './myUpload.vue'
// @ts-ignore
import templatepage from './template.vue'
import { useUserStore } from '@/stores/user'
const userStore = useUserStore()
const islogin = userStore.isLoggedIn
const keywords = ref('')
const tabs = [
  { name: 'work' as const, label: '作品' },
  { name: 'myUpload' as const, label: '我上传的' }
]
const activeTab = ref('work')
const folderOpen = ref(false)

const folders = ref([])
const resourceCount = ref(0)
const filterOn = ref(false)
const folderOn = ref(false)
const folderActive = ref({})
const handleFolderClick = (item: any) => {
  folderOn.value = true
  folderActive.value = item
  getList()
}
const fileInput = ref<HTMLInputElement | null>(null)
const myUploadRef = ref<myUpload>()
const handleBackClick = () => {
  // folderActive
  let folders = {
    id: (folderActive.value as any)?.parent_folder_id || '',
    name: (folderActive.value as any)?.parent_name || ''
  }
  folderActive.value = folders
  getList()
}
const onPlusCommand = async (cmd: string) => {
  if (cmd === 'upload') {
    fileInput.value?.click()
    return
  }
  if (cmd === 'folder') {
    try {
      const { value } = await ElMessageBox.prompt('请输入文件夹名称', '创建文件夹', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
      if (value && String(value).trim()) {
        createFolder({ name: String(value).trim(), parent_folder_id: (folderActive.value as any)?.id || '' }).then(res => {
          if (res.data.code === 200) {
            ElMessage.success('文件夹已创建')
            getList()
          }
        })
      }
    } catch (_) { }
  }
}
const handleLogin = () => {
  ; (window as any).openGlobalLogin?.()
}
const remainingCapacity = ref(0)
onMounted(() => {
  if (!islogin) {
    return
  }
  getList()
  getCapacity()
})
const getCapacity = () => {
  getResourceCapacity({}).then(res => {
    if (res.data.code == 200) {
      let arr = res.data.data
      arr.prop = arr.used_capacity / arr.capacity
      remainingCapacity.value = arr
    }
  })
}
const getList = () => {
  getFolderList({ parent_folder_id: (folderActive.value as any)?.id || '' }).then(res => {
    if (res.data.code == 200) {
      folders.value = res.data.data
    }
  })
}
const onFileChange = async (e: Event) => {
  const files = (e.target as HTMLInputElement).files
  if (!files || files.length === 0) return
  // ElMessage.success(`已选择 ${files.length} 个文件`)
  //   ; (e.target as HTMLInputElement).value = ''
  console.log(files[0])

  const folder_id = (folderActive.value as any)?.id || ''
  const res = await resourcerFileUpload(files[0], folder_id)
  if (res.data.code === 200) {
    myUploadRef.value?.getList()
    getCapacity()
  }
}
const getResourceList = (data: any) => {

}
</script>

<style lang="scss" scoped>
.panel-title {
  font-size: 16px;
  line-height: 22px;
  color: #0b1029;
  font-weight: 600;
  display: flex;
  align-items: center;

}

.select-bg {
  font-weight: bolder;
}
</style>
